var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMessage = function SvgMessage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 16
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#006bb7",
    d: "M19.718 13.17c0 .747-.608 1.355-1.356 1.355H2.942a1.357 1.357 0 0 1-1.355-1.355V2.635c0-.748.608-1.356 1.355-1.356h15.416c.748 0 1.356.608 1.356 1.356V13.17zM18.362.135H2.942A2.5 2.5 0 0 0 .447 2.63v10.54a2.5 2.5 0 0 0 2.495 2.495h15.416a2.5 2.5 0 0 0 2.496-2.495V2.635a2.495 2.495 0 0 0-2.492-2.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#006bb7",
    d: "m13.317 7.77 4.99-4.477a.573.573 0 0 0 .043-.806.573.573 0 0 0-.807-.042l-6.882 6.177-1.343-1.2q-.007-.005-.008-.012a1 1 0 0 0-.093-.08L3.753 2.44a.57.57 0 0 0-.807.047.57.57 0 0 0 .047.806l5.05 4.514-5.03 4.708a.572.572 0 0 0 .782.836L8.9 8.576l1.385 1.237a.57.57 0 0 0 .76-.004l1.423-1.276 5.075 4.822a.57.57 0 0 0 .785-.828z"
  })));
};
export default SvgMessage;